export default "__VITE_ASSET__B682a60W__"